// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2IeYk","amount":"Amount_amount__2ChuY","tip":"Amount_tip__1Zfom","tipHeader":"Amount_tipHeader__3Pbfj","tipsWrap":"Amount_tipsWrap__GF9d8"};